const clientPersonTypes = [
    {
        name: "CLIENT",
        value: 1
    },
    {
        name: "ACCOUNTING",
        value: 2
    },
    {
        name: "OTHER",
        value: 3
    },
]

export default clientPersonTypes;